import { render, staticRenderFns } from "./request-timeline.component.vue?vue&type=template&id=90408432"
import script from "./request-timeline.component.vue?vue&type=script&lang=ts"
export * from "./request-timeline.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports